module.exports = __webpack_public_path__ + "static/Transcend-8890767d4eaaa04e4d606cbc181d1d97.jpg";